const api = 'https://cms-cote.allianz.com.br/'

export const environment = {
	api: `${api}`,
	env: 'prod',
	splitPoint: '.br',
	production: true
}
